
$(function () {
    $(".widget-dropdown").each(function (idx, element) {

        var _hideToggleListeners = function (allExcept) {
            var listeners = $(element).data("toggle-listeners");

            if (listeners && listeners.length > 0) {
                for (var i = 0; i < listeners.length; i++) {
                    if (listeners[i] != allExcept) {
                        $("#" + listeners[i]).hide();
                    }
                }
            }
        }

        var _hidrateToggleListeners = function () {
            var listeners = [];
            var $items = $(element).find("li[data-show-on-select]");
            var selectedValue = $(element).val();

            for (var i = 0; i < $items.length; i++) {
                var $item = $items.eq(i);
                var value = $item.data("value");
                var listener = $item.data("show-on-select");

                if (listener) {
                    listeners.push(listener);

                    if (value == selectedValue)
                        $("#" + listener).show();
                }
            }

            $(element).data("toggle-listeners", listeners);
        }

        setTimeout(function () {
            //delayed execution
            _hidrateToggleListeners();
        }, 200);

        $(element).find("li").click(function () {
            var text = $(this).text();
            var value = $(this).data("value");
            var toggleListener = $(this).data("show-on-select");
            var iconClass = $(this).find("a i").attr("class");

            if (toggleListener) {
                $("#" + toggleListener).show();
                _hideToggleListeners(toggleListener);
            }
            else {
                _hideToggleListeners();
            }

            $(element).children("button").eq(0).find("span").html(text);
            $(element).children("button").eq(0).attr("title", text);
            $(element).children("input[type=hidden]").val(value);

            if (iconClass) {
                $(element).children("button").eq(0).find("i").attr("class", iconClass);
            }

            //trigger events
            $(element).trigger("change");
            $(element).trigger(WidgetEvents.STEMS_ON_CHANGE, { text: text, value: value });            

        });
    });
});